'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertFailure = require('./components/AlertFailure.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertFailure).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/failure/index.js
// module id = 1017
// module chunks = 1